<template>
  <div class="pa0 ma0">
    <a :href="'/pro/profile/' + proUser.id" :target="profileLinkTarget" class="cursor dim">
        <pro-project-thumbnail-photo :project="project" :width="280"></pro-project-thumbnail-photo>
    </a>
    <div class="flex items-center">
    <div class="flex-auto top--4 relative">
        <div class="pl3">
        <a :href="'/pro/profile/' + proUser.id" :target="profileLinkTarget">
            <img v-if="!proUser.profilePicture" src="https://avvay-aws-production.imgix.net/site-assets/default-avatar.png?w=64&h=64&crop=fit&mask=ellipse&faceindex=1&fit=facearea&facepad=2&mark64=aHR0cHM6Ly9zMy5hbWF6b25hd3MuY29tL2VzLm1ha2VzcGFjLmNvcmUuYXdzLnByb2R1Y3Rpb24ucHVibGljL3NpdGUtYXNzZXRzL3Byb21hcmsucG5n&markpad=2&fm=png" :alt="proUser.fullName" class="cursor">
            <img v-if="proUser.profilePicture" :src="env.userMediaUrl + proUser.profilePicture + '?w=64&h=64&crop=fit&mask=ellipse&faceindex=1&fit=facearea&facepad=2&mark64=aHR0cHM6Ly9zMy5hbWF6b25hd3MuY29tL2VzLm1ha2VzcGFjLmNvcmUuYXdzLnByb2R1Y3Rpb24ucHVibGljL3NpdGUtYXNzZXRzL3Byb21hcmsucG5n&markpad=2&fm=png'" :alt="proUser.fullName" class="cursor" />
        </a>
        <ul class="list ma0 pa0">
            <li class="f4 fw6 mv2">{{proUser.fullName | truncate(40)}}</li>
            <li class="gray f4 mv2">{{proUser.proProfile.jobTitle | truncate(40)}}</li>
            <li class="near-black f4 mv2">{{proUser.homeAddress.city}}</li>
        </ul>
        </div>
      </div>
    </div>
    <pro-project-details-modal @modalClose="showModal=false" v-if="showModal"></pro-project-details-modal>
  </div>
</template>

<script>

import proProjectThumbnailPhoto from '../../project/components/ProProjectThumbnailPhoto'
import proProjectDetailsModal from '../../project/components/ProProjectDetailsModal'
import proProjectReactionForm from '../../project/components/ProProjectReactionForm'
import projectService from '../../../../api/ProjectService'
import { mapState } from 'vuex'

export default {
  name: 'ProProfileCard',
  components: { proProjectThumbnailPhoto, proProjectDetailsModal, proProjectReactionForm },
  props: {
      project: {
          type: Object,
          required: true,
      },
      proUser: {
          type: Object,
          required: true,
      },
      showDetailsOnRender: {
          type: Boolean,
          default: false,
          required: false,
      },
      profileLinkTarget: {
          type: String,
          default: '_self',
          required: false,
      }
  },
  computed : {
      ...mapState(['env']),
  },
  data() {
      return {
          showModal: false
      }
  },
  methods: {
      handleProjectClick(projectToShowId) {
          console.log(projectToShowId);
          this.showModal=true;
          projectService.getProject(projectToShowId).then(response => {
              this.$modal.show('pro-project-details-modal',
                  {
                      project: response.data,
                      previewMode: false,
                  });
          });
      },
  },

  created() {
      if(this.showDetailsOnRender) {
          this.handleProjectClick(this.project.id);
      }

  },

  filters: {
      truncate: function(value, limit) {
          if (value.length > limit) {
              value = value.substring(0, (limit - 3)) + '...';
          }

          return value
      }
  },

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/main/frontend/vue/js/modules/pro/profile/components/ProProfileCard.vue